import {z} from 'zod';

export const WheelSchema = z.object({
  id: z.string().nullish(),
  checked: z.boolean().nullish(),
  manufacturer: z.string().nullish(),
  tireWidth: z.string().nullish(),
  aspectRatio: z.string().nullish(),
  rim: z.string().nullish(),
  tread: z.number().nullish(),
  rimType: z.string().nullish(),
  season: z.string().nullish(),
  li: z.string().nullish(),
  sr: z.string().nullish(),
  dot: z.string().nullish(),
  location: z.string().nullish(),
  title: z.string().nullish(),
  hasHubcap: z.boolean(),
  hasWheelLocks: z.boolean(),
  tireCondition: z.string().nullish(),
  note: z.string().nullish(),
});

export type Wheel = z.infer<typeof WheelSchema>;
